import React from 'react';
import { connect } from 'dva';
import { createStructuredSelector } from 'reselect';
import Spinner from '@mos-front-components/public/es/components/Spinner/Spinner';

import {
  isAddressSpinnerVisible,
  PersonModel,
} from '../../../../selectors/addressUnmodeled';

interface StateProps {
  isVisible: boolean;
}

interface OwnProps {
  model: PersonModel;
  forManualInput?: boolean;
}

type Props = OwnProps & StateProps;

function AddressSpinner({ isVisible }: Props): JSX.Element | null {
  if (!isVisible) return null;
  return (
    <div className="PguFormGrid__row">
      <div className="Spinner__Wrapper">
        <Spinner overlayVisible={false} />
      </div>
    </div>
  );
}

const mapStateToProps = createStructuredSelector({
  isVisible: isAddressSpinnerVisible,
});

export default connect(mapStateToProps)(AddressSpinner);
